import { render, staticRenderFns } from "./SearchField.vue?vue&type=template&id=65fb464e&lang=pug&"
import script from "./SearchField.vue?vue&type=script&lang=ts&"
export * from "./SearchField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports